<template>
  <div>
    <FormGroup :id="id" :label="label" :hint="hint">
      <div class="relative">
        <SimpleInput
          type="number"
          :model-value="modelValue"
          :placeholder="placeholder"
          :loading="loading"
          :has-error="error"
          :model-modifiers="{
            maxDecimals: 2,
          }"
          :class="disabled && 'bg-neutral-99 pointer-events-none select-none'"
          class="mt-1 pl-9 pr-16"
          @update:model-value="UpdateModelValue"
          @blur="EmitBlur"
        />
        <span :class="disabled ? 'text-neutral-80' : 'text-neutral-70'" class="absolute left-4 top-1.5">{{
          CurrenciesSimbols[currency]
        }}</span>
        <span
          v-if="!loading"
          :class="disabled ? 'text-neutral-80' : 'text-neutral-70'"
          class="absolute right-4 top-1.5"
          >{{ currency }}</span
        >
      </div>
    </FormGroup>
  </div>
</template>

<script lang="ts">
export enum Currencies {
  ARS = "ARS",
  BRL = "BRL",
  USD = "USD",
  EUR = "EUR",
  MXN = "MXN",
  PEN = "PEN",
  PYG = "PYG",
  UYU = "UYU",
  GTQ = "GTQ",
  HNL = "HNL",
  SVC = "SVC",
  CLP = "CLP",
  COP = "COP",
  CRC = "CRC",
  BOB = "BOB",
  CAD = "CAD",
  VEF = "VEF",
}
</script>

<script lang="ts" setup>
import { v4 as uuid } from "uuid";

//Components
import FormGroup from "@molecules/FormGroup.vue";
import SimpleInput from "@atoms/SimpleInput.vue";

enum CurrenciesSimbols {
  ARS = "$",
  BRL = "R$",
  USD = "$",
  EUR = "€",
  MXN = "$",
  PEN = "S/",
  PYG = "₲",
  UYU = "$",
  GTQ = "Q",
  HNL = "L",
  SVC = "$",
  CLP = "$",
  COP = "$",
  CRC = "₡",
  BOB = "$",
  CAD = "$",
  VEF = "Bs",
}

//Props
withDefaults(
  defineProps<{
    id?: string;
    modelValue: string;
    currency: Currencies;
    label?: string;
    hint?: string;
    placeholder?: string;
    error: boolean;
    disabled?: boolean;
    loading?: boolean;
  }>(),
  {
    id: uuid(),
    modelValue: "",
    currency: Currencies.ARS,
    label: "",
    hint: "",
    placeholder: "0.00",
    error: false,
    disabled: false,
    loading: false,
  },
);

//Emits
const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "blur", ev: Event): void;
}>();

const UpdateModelValue = (value: string) => emit("update:modelValue", value);

const EmitBlur = (ev: Event) => emit("blur", ev);
</script>
